import script from "./TipOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./TipOverlay.vue?vue&type=script&setup=true&lang=js"

import "./TipOverlay.vue?vue&type=style&index=0&id=fd3741f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd3741f4"]])

export default __exports__